import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi.ts';

export interface UserConsentInput {
    essentialCookies: boolean;
    analyticsCookies: boolean;
    consentVersion?: string;
}

export interface UserPreferences {
    essentialCookies: boolean;
    analyticsCookies: boolean;
    hasConsent: boolean;
    consentDate?: string;
    consentVersion?: string;
    mmeCalculatorWarningAccepted: boolean;
    alertBellMinSeverity: string;
}

export interface UserConsentResponse {
    id: number;
    userID?: number;
    essentialCookies: boolean;
    analyticsCookies: boolean;
    consentDate: string;
    lastUpdatedDate: string;
    ipAddress?: string;
    userAgent?: string;
    consentVersion: string;
    mmeCalculatorWarningAccepted: boolean;
}

export interface MMEWarningAcceptanceInput {
    accepted: boolean;
}

export interface AlertBellMinSeverityInput {
    minSeverity: string;
}

export class UserConsentsApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/UserConsents`;

    public static apiUrls = {
        saveConsent: `${UserConsentsApi.baseApiUrl}`,
        getPreferences: `${UserConsentsApi.baseApiUrl}/preferences`,
        updatePreferences: `${UserConsentsApi.baseApiUrl}/preferences`,
        revokeConsent: `${UserConsentsApi.baseApiUrl}`,
        updateMMEWarning: `${UserConsentsApi.baseApiUrl}/mme-warning`,
        updateAlertBellSeverity: `${UserConsentsApi.baseApiUrl}/alert-bell-severity`,
    };

    public static async saveConsent(consent: UserConsentInput): Promise<UserConsentResponse> {
        return this.sendApiRequest<UserConsentResponse>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.saveConsent,
            data: consent,
            suppressGlobalErrorHandling: true,
        });
    }

    public static async getPreferences(): Promise<UserPreferences> {
        return this.sendApiRequest<UserPreferences>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getPreferences,
            suppressGlobalErrorHandling: true,
        });
    }

    public static async updatePreferences(consent: UserConsentInput): Promise<UserConsentResponse> {
        return this.sendApiRequest<UserConsentResponse>({
            method: HttpMethodEnum.PUT,
            path: this.apiUrls.updatePreferences,
            data: consent,
            suppressGlobalErrorHandling: true,
        });
    }

    public static async revokeConsent(): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.DELETE,
            path: this.apiUrls.revokeConsent,
            suppressGlobalErrorHandling: true,
        });
    }

    public static async patchMMEWarning(input: MMEWarningAcceptanceInput): Promise<UserConsentResponse> {
        return this.sendApiRequest<UserConsentResponse>({
            method: HttpMethodEnum.PATCH,
            path: this.apiUrls.updateMMEWarning,
            data: input,
            suppressGlobalErrorHandling: true,
        });
    }

    public static async patchAlertBellMinSeverity(input: AlertBellMinSeverityInput): Promise<UserConsentResponse> {
        return this.sendApiRequest<UserConsentResponse>({
            method: HttpMethodEnum.PATCH,
            path: this.apiUrls.updateAlertBellSeverity,
            data: input,
            suppressGlobalErrorHandling: true,
        });
    }
}
